import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { ListHeaderTitle } from "components/List";
import { useTranslation } from "react-i18next";

type Props = {
  children: React.ReactElement;
  testId: string;
};

export default function TitleAndTable({ children, testId }: Props) {
  const { t } = useTranslation("users");
  return (
    <>
      <TableContainer component={Paper}>
        <Table data-testid={testId} size="small">
          <TableHead>
            <TableRow style={{ height: "48px" }}>
              <TableCell>
                <ListHeaderTitle variant="button">{t("name")}</ListHeaderTitle>
              </TableCell>
              <TableCell>
                <ListHeaderTitle variant="button">
                  {t("common:email")}
                </ListHeaderTitle>
              </TableCell>
              <TableCell>
                <ListHeaderTitle variant="button">{t("role")}</ListHeaderTitle>
              </TableCell>
              <TableCell>
                <ListHeaderTitle variant="button">
                  {t("access")}
                </ListHeaderTitle>
              </TableCell>
              <TableCell>
                <ListHeaderTitle variant="button">
                  {t("lastUpdated")}
                </ListHeaderTitle>
              </TableCell>
            </TableRow>
          </TableHead>
          {children}
        </Table>
      </TableContainer>
    </>
  );
}
